import { render, staticRenderFns } from "./businessShift.vue?vue&type=template&id=1867ed31&scoped=true"
import script from "./businessShift.vue?vue&type=script&lang=js"
export * from "./businessShift.vue?vue&type=script&lang=js"
import style0 from "./businessShift.vue?vue&type=style&index=0&id=1867ed31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1867ed31",
  null
  
)

export default component.exports